import React from 'react';
import ProductCard from './ProductCard';
import LoadingSpinner from '../../../components/common/LoadingSpinner';

export default function ProductGrid({
  products,
  selectedBrowsingGroup,
  setSelectedBrowsingGroup,
  availableBrowsingGroups,
  onProductSelect
}) {
  // Create browsing groups array with "all" option
  const browsingGroups = ['all', ...availableBrowsingGroups];

  return (
    <div className="space-y-6">
      {/* BrowsingGroup Filter */}
      <div className="bg-white rounded-xl shadow-lg border border-[#19BFB7]/20 p-6">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 max-w-xs">
            <label className="block text-sm font-medium text-[#011841] mb-2">Selection</label>
            <select
              value={selectedBrowsingGroup}
              onChange={(e) => setSelectedBrowsingGroup(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19BFB7] focus:border-transparent"
            >
              {browsingGroups.map(group => (
                <option key={group} value={group}>
                  {group === 'all' ? 'All Products' : group}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Results Count */}
      <div className="flex justify-between items-center">
        <p className="text-gray-600">
          {products.length} {products.length === 1 ? 'product' : 'products'} available
        </p>
        {selectedBrowsingGroup !== 'all' && (
          <button
            onClick={() => setSelectedBrowsingGroup('all')}
            className="text-sm text-[#033EA5] hover:text-[#022b73] font-medium"
          >
            Clear selection
          </button>
        )}
      </div>

      {/* Product Grid */}
      {products.length === 0 ? (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">🔍</div>
          <h3 className="text-xl font-semibold text-[#011841] mb-2">No products found</h3>
          <p className="text-gray-600 mb-4">
            No products available for the selected selection
          </p>
          {selectedBrowsingGroup !== 'all' && (
            <button
              onClick={() => setSelectedBrowsingGroup('all')}
              className="px-6 py-2 bg-[#033EA5] hover:bg-[#022b73] text-white rounded-lg font-medium transition-all duration-300"
            >
              View All Products
            </button>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onProductSelect={onProductSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
}
